import { createRoute } from '@tanstack/react-router'
import { projectRoute } from '../route'
import { KanbanBoard } from '@/components/kanban-board'

export interface TasksSearchParams {
  task?: string
}

export const tasksRoute = createRoute({
  getParentRoute: () => projectRoute,
  path: '/tasks/',
  component: TasksPage,
  validateSearch: (search: Record<string, unknown>): TasksSearchParams => ({
    task: typeof search.task === 'string' ? search.task : undefined,
  }),
})

function TasksPage() {
  const { projectId } = tasksRoute.useParams()
  const { task: initialTaskId } = tasksRoute.useSearch()
  return (
    <div className="flex-1 overflow-hidden">
      <KanbanBoard projectId={projectId} initialTaskId={initialTaskId} />
    </div>
  )
}
